import actions from './actions';
import { DataService } from '../../config/dataService/dataService';
import HttpStatus from '../../utility/status.enum';

const { getExportSettingsBegin, getExportSettingsSuccess, getExportSettingsErr, updateExportSettingsBegin, updateExportSettingsSuccess, updateExportSettingsErr, getExportLogsBegin, getExportLogsSuccess, getExportLogsErr } = actions;

const GetExportSettingsAPI = `/admin/get-export-settings`;
const UpdateExportSettingsAPI = `/admin/add-edit-export-settings`;
const getExportLogsAPI = `/admin/get-export-logs`;

const getExportSettings = (values = "") => {
  return async (dispatch) => {
   dispatch(getExportSettingsBegin());
    try {
      const response = await DataService.get(GetExportSettingsAPI + values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(getExportSettingsErr(response?.data?.message));
      } else {
        dispatch(getExportSettingsSuccess(response?.data));
      }
      return response?.data;    
    } catch (err) {
      dispatch(getExportSettingsErr(err));
    }
    }
};

const updateExportSettings = (values) => {
  return async (dispatch) => {
    dispatch(updateExportSettingsBegin());
    try {
      const response = await DataService.post(UpdateExportSettingsAPI, values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(updateExportSettingsErr(response?.data?.message));
      } else {
        dispatch(updateExportSettingsSuccess(response?.data));
      }
      return response?.data;    
    } catch (err) {
      dispatch(updateExportSettingsErr(err));
    }
  } 
};

const getExportLogs = (values = "") => {
  return async (dispatch) => {
    dispatch(getExportLogsBegin());
    try {
      const response = await DataService.get(getExportLogsAPI  + values);
      if (response?.data?.status !== HttpStatus.HTTP_OK) {
        dispatch(getExportLogsErr(response?.data?.message));
      } else {
        dispatch(getExportLogsSuccess(response?.data));
      }
      return response?.data;    
    } catch (err) {
      dispatch(getExportLogsErr(err));
    }
  } 
};

export { updateExportSettings, getExportSettings, getExportLogs };
